import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  CardHeader,
  Avatar,
  CardMedia,
  Box,
  IconButton,
  Stack,
  Menu,
  MenuItem,
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  Switch,
  DialogActions,
  Checkbox,
  List,
  ListItem,
  ListItemText,
  Tooltip,
  CircularProgress,
  Chip,
  TextField,
} from "@mui/material";
import LinkPreview from "../../../shared/LinkPreview";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import StarIcon from "@mui/icons-material/Star";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import SettingsIcon from "@mui/icons-material/Settings";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import "./Postcard.css";
import PostDailog from "../PostDailog/Postdailog";
import edit from "../../../assets/edit.png";
import share from "../../../assets/share.png";
import CloseIcon from "@mui/icons-material/Close";
import FacebookIcon from "../../../assets/facebook.png";
import InstagramIcon from "../../../assets/insta.png";
import LinkedInIcon from "../../../assets/linkedin.png";
import TwitterIcon from "../../../assets/twitter.png";
import whatsapp from "../../../assets/whatsapp.svg";
import youtube from "../../../assets/socialmedia/youtube.svg";
import noImage from "../../../assets/noimage.jpg";
import logoImg from "../../../assets/SocialRipplelogo_J.png";
import SharePostPopup from "../../sharePostPopup/SharePostPopup";
import PostDetails from "./PostDetails";
import {
  getAllPlatforms,
  createFacebookExternalPost,
  createInstagramExternalPost,
  createLinkedinExternalPost,
  createXExternalPost,
  createYoutubeExternalPost,
  deletePost,
  getPosts,
  postDetailsByPostId,
  postSummary,
  preparePost,
  updatePostSettings,
  engagePost,
  visitFeaturedPost,
} from "../../../services/postService";
import { useLocation, Link, useNavigate } from "react-router-dom";
import { Auth } from "../../../contexts/AuthContext";
import { toast } from "react-toastify";
import { composePlatformContent, formatPlatformErrorMessage } from "../../../shared/businessPageComposer";
import { FormatPostContent } from "../../../shared/formatPostContent";
import { buildPublicShareUrl } from "../../../services/runtimeConfig";
import {
  BLACK_THUMBNAIL,
  getBunnyEmbedUrl,
  getResolvedImageUrl,
  getResolvedPosterUrl,
  getResolvedVideoUrl,
  isBunnyStreamMedia,
  isDocumentMedia,
  isVideoMedia,
} from "../../../shared/mediaResolver";

const getSystemHashtags = (post = {}) => {
  const candidates = [post?.hashtags, post?.hashTags, post?.postHashtags];
  const source = candidates.find((value) => Array.isArray(value)) || [];
  return source
    .map((tag) => {
      if (typeof tag === "string") {
        return tag.trim();
      }
      return (
        tag?.tag ||
        tag?.name ||
        tag?.value ||
        tag?.hashtag ||
        ""
      ).trim();
    })
    .filter(Boolean);
};

// Build the public share-page URL for a post (/v1/public/posts/{id}). The server-rendered
// page carries Open Graph tags so WhatsApp shows a rich preview card with image + title.
const getPublicShareUrl = (post) => buildPublicShareUrl(post?.id);

const appendMediaToWhatsAppText = (text, post) => {
  // 1. Clean the caption: replace/remove broken lnkd.in links
  let cleanText = text || "";
  if (post?.featuredUrl && !post.featuredUrl.startsWith("urn:")) {
    cleanText = cleanText.replace(/https?:\/\/lnkd\.in\/[a-zA-Z0-9]+/g, post.featuredUrl);
  } else {
    cleanText = cleanText.replace(/https?:\/\/lnkd\.in\/[a-zA-Z0-9]+/g, "");
  }

  let finalMsg = cleanText.trim();

  // 2. Extract direct media link
  const imageMedia = post?.media?.find((m) => m?.mediaType?.toUpperCase() === "IMAGE");
  const videoMedia = post?.media?.find((m) => m?.mediaType?.toUpperCase() === "VIDEO");
  const mediaUrl =
    (post?.featuredUrl && !post.featuredUrl.startsWith("urn:") ? post.featuredUrl : null) ||
    (imageMedia ? getResolvedImageUrl(imageMedia) : null) ||
    (videoMedia ? getResolvedVideoUrl(videoMedia) : null);

  // 3. Append the public share-page URL so WhatsApp shows a rich preview card.
  const shareUrl = getPublicShareUrl(post);
  if (shareUrl) {
    finalMsg += `\n\n${shareUrl}`;
    if (mediaUrl && mediaUrl !== post?.featuredUrl) {
      finalMsg += `\n\nMedia Link: ${mediaUrl}`;
    }
  } else if (mediaUrl) {
    finalMsg += `\n\n${mediaUrl}`;
  }

  return finalMsg.trim();
};

const getTimeAgo = (dateStr) => {
  if (!dateStr) return "";
  const date = typeof dateStr === 'string' && !dateStr.endsWith('Z') ? `${dateStr}Z` : dateStr;
  const seconds = Math.floor((Date.now() - new Date(date)) / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (seconds < 60) return `${Math.max(0, seconds)}s ago`;
  if (minutes < 60) return `${minutes}m ago`;
  if (hours < 24) return `${hours}h ago`;
  return `${days}d ago`;
};

const platform = [
  { name: "Linkedin", icon: LinkedInIcon },
  { name: "Twitter / X", icon: TwitterIcon },
  // { name: "Instagram", icon: InstagramIcon },
  // { name: "Youtube", icon: youtube },
  // { name: "Facebook", icon: FacebookIcon },
  // { name: "WhatsApp", icon: whatsapp },
  // { name: "Internal", icon: StarIcon },
];

const PLATFORM_ICON_MAP = {
  FACEBOOK: FacebookIcon,
  INSTAGRAM: InstagramIcon,
  LINKEDIN: LinkedInIcon,
  X: TwitterIcon,
  TWITTER: TwitterIcon,
  TWEET: TwitterIcon,
  YOUTUBE: youtube,
  WHATSAPP: whatsapp,
};

const PLATFORM_LABEL_MAP = {
  FACEBOOK: "Facebook",
  INSTAGRAM: "Instagram",
  LINKEDIN: "LinkedIn",
  X: "X",
  TWITTER: "X",
  TWEET: "X",
  YOUTUBE: "YouTube",
  WHATSAPP: "WhatsApp",
};

const getPlatformIcon = (post) => PLATFORM_ICON_MAP[post?.type?.toUpperCase()] || null;
const getPlatformLabel = (post) => PLATFORM_LABEL_MAP[post?.type?.toUpperCase()] || post?.type;

const isSocialPlatform = (type) => {
  if (!type) return false;
  const p = String(type).toUpperCase();
  return ["LINKEDIN", "X", "TWITTER", "TWEET", "FACEBOOK", "INSTAGRAM", "YOUTUBE", "WHATSAPP"].includes(p);
};

export const isPayoneerSubdomain = (businessPages = {}) => {
  try {
    const host = (typeof window !== "undefined" ? window.location.hostname : "").toLowerCase();
    if (host.includes("payoneer") || host.includes("payoneers")) return true;
    const orgName = (businessPages?.orgName || "").toLowerCase();
    if (orgName.includes("payoneer") || orgName.includes("payoneers")) return true;
    const sub = (
      (typeof sessionStorage !== "undefined" && (sessionStorage.getItem("orgSubdomain") || sessionStorage.getItem("organizationSubdomain"))) ||
      (typeof localStorage !== "undefined" && (localStorage.getItem("orgSubdomain") || localStorage.getItem("organizationSubdomain"))) ||
      ""
    ).toLowerCase();
    if (sub.includes("payoneer") || sub.includes("payoneers")) return true;
  } catch (e) { }
  return false;
};

const isDisallowedPayoneerPlatform = (platform) => {
  if (!isPayoneerSubdomain()) return false;
  const p = String(platform || "").toUpperCase();
  return p === "INSTAGRAM" || p === "YOUTUBE" || p === "FACEBOOK";
};

export const isCreatedContentPost = (post) => {
  if (!post) return false;
  const srcType = String(post?.sourceType || "").toUpperCase();
  const type = String(post?.type || "").toUpperCase();
  if (srcType === "BUSINESS_PAGE" || srcType === "LEADER_PROFILE") return false;
  if (["LINKEDIN", "X", "TWITTER", "TWEET", "FACEBOOK", "INSTAGRAM", "YOUTUBE"].includes(type)) return false;
  return true;
};

const getDisplayName = (post) => {
  const isSocial = isSocialPlatform(post?.type) && (post?.sourceType === "BUSINESS_PAGE" || post?.sourceType === "LEADER_PROFILE");

  if (!isSocial) {
    // 1. Category name from post.type (if set)
    if (post?.type && !isSocialPlatform(post.type) && String(post.type).toUpperCase() !== "MANUAL") {
      return post.type;
    }

    // 2. Category name from post.categories array
    const categoryName =
      post?.categories?.map((c) => c?.categoryName || c?.name).filter(Boolean).join(", ") ||
      post?.postCategory?.map((c) => c?.categoryName || c?.name).filter(Boolean).join(", ") ||
      post?.categoryName;

    if (categoryName) return categoryName;

    // 3. Category name from sourceName
    if (
      post?.sourceName &&
      post?.sourceName.toUpperCase() !== "MANUAL" &&
      !post?.sourceName.toUpperCase().endsWith(" MANUAL") &&
      post?.sourceName !== post?.createdBy?.name
    ) {
      return post.sourceName;
    }
    return post?.organizationName || post?.createdBy?.name || "Post";
  }

  if (post?.sourceName && post?.sourceName !== post?.createdBy?.name) {
    return post.sourceName;
  }
  const platform = getPlatformLabel(post) || "";
  const orgName = post?.organizationName || "";
  if (orgName && platform) return `${orgName} ${platform}`;
  if (orgName) return orgName;
  return platform;
};
const getDisplayUsername = (post) => post?.sourceUsername || null;
const getDisplayAvatar = (post, userProfile) => {
  if (post?.sourceAvatarUrl) return post.sourceAvatarUrl;
  if (post?.organizationLogoUrl) return post.organizationLogoUrl;
  if (post?.organization?.logoUrl) return post.organization.logoUrl;
  if (post?.organizationLogo) return post.organizationLogo;
  if (userProfile?.organization?.logoUrl) return userProfile.organization.logoUrl;
  if (userProfile?.organizationLogoUrl) return userProfile.organizationLogoUrl;
  if (userProfile?.logoUrl) return userProfile.logoUrl;
  if (userProfile?.organizationLogo) return userProfile.organizationLogo;
  if (post?.createdBy?.profileImageUrl) return post.createdBy.profileImageUrl;
  return logoImg;
};

const getSourceLabel = (post) => {
  if (post?.sourceType === "LEADER_PROFILE") {
    return "Leader Profile";
  }
  if (post?.sourceType === "BUSINESS_PAGE") {
    return "Business Page";
  }
  return null;
};

// Posts ingested from social media (leader profiles, business pages, external platforms)
// can only be deleted — they cannot be edited/updated. Manual (in-app) posts can be edited.
const isSocialSourcePost = (post) => {
  if (!post) return false;
  if (post.sourceType && post.sourceType !== "MANUAL") return true;
  if (post.type && PLATFORM_ICON_MAP[String(post.type).toUpperCase()]) return true;
  return false;
};

const getParsedVariations = (content) => {
  if (!content) return null;
  try {
    const str = String(content).trim();
    if (!str.startsWith("[")) return null;
    const escaped = str.replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\t/g, "\\t");
    const parsed = JSON.parse(escaped);
    if (Array.isArray(parsed) && parsed.length > 0 && parsed[0].content !== undefined) {
      return parsed;
    }
  } catch (e) {
    // Not valid JSON
  }
  return null;
};

const getDisplayContent = (content, index = 0) => {
  const variations = getParsedVariations(content);
  return variations && variations[index] ? variations[index].content || "" : content || "";
};

const PostCards = ({ refreshFeed, onEditPost }) => {
  const location = useLocation();
  const loca = location.pathname.split("/").filter(Boolean).pop();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("category");
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [selectedPost, setSelectedPost] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [postsList, setPostsList] = useState([]);
  const [postDetails, setPostDetails] = useState(false);
  const [singlePost, setSinglePost] = useState(null);
  const [clickedPost, setClickedPost] = useState([]);
  const [openSharePopup, setOpenSharePopup] = useState(false);
  const [sharePopupVariationIndex, setSharePopupVariationIndex] = useState(0);
  const [postReviewData, setPostReviewData] = useState(null);
  const [currentImageIndexes, setCurrentImageIndexes] = useState({});
  const [currentVariationIndexes, setCurrentVariationIndexes] = useState({});
  const [connectDialogPlatform, setConnectDialogPlatform] = useState(null);
  const navigate = useNavigate();

  const handleVariationChange = (postId, direction, totalVariations, e) => {
    e.stopPropagation();
    setCurrentVariationIndexes((prev) => {
      const current = prev[postId] ?? 0;
      let next = current + direction;
      if (next < 0) next = totalVariations - 1;
      if (next >= totalVariations) next = 0;
      return { ...prev, [postId]: next };
    });
  };

  const [openDialog, setOpenDialog] = useState(false);
  const [showTagMap, setShowTagMap] = useState({});
  const [showTag, setShowTag] = useState(false);
  const [selectedPlatform, setSelectedPlatform] = useState("");
  const [openSettingsDialog, setOpenSettingsDialog] = useState(false);
  const [settingsPost, setSettingsPost] = useState(null);
  const [settingsAllowEdit, setSettingsAllowEdit] = useState(false);
  const [settingsCategories, setSettingsCategories] = useState([]);
  const [settingsSaving, setSettingsSaving] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const [featuredDeletePost, setFeaturedDeletePost] = useState(null);
  const [shareLoading, setShareLoading] = useState(false);
  const authContext = Auth();
  const { businessPages, categoriesData, userProfile, refreshLoyaltyPoints } = authContext;
  const isAdmin = JSON.parse(sessionStorage.getItem("role") || "[]")
    .flat().includes("ROLE_ADMIN");
  const categoryList = authContext;
  const featuredCategory = categoriesData?.find(
    (c) => c.name?.toLowerCase() === "featured"
  ) || null;
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(50);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [loadingPostId, setLoadingPostId] = useState(null);
  const [summary, setSummary] = useState("");
  const [activeBunnyPlayers, setActiveBunnyPlayers] = useState({});
  const [personalConnections, setPersonalConnections] = useState({});

  useEffect(() => {
    const fetchConnections = async () => {
      try {
        const response = await getAllPlatforms();
        if (response?.status === true) {
          const data = response?.socialMediaConnectionData || [];
          const connected = {};
          data.forEach(item => {
            if (item.status === "CONNECTED") {
              connected[item.platform.toUpperCase()] = true;
            }
          });
          setPersonalConnections(connected);
        }
      } catch (e) { }
    };
    fetchConnections();
  }, []);

  // Deep-link: when the user arrives via a WhatsApp shared link (/employees/timeline?post=123),
  // auto-open the post detail popup for that post so they see it immediately after login.
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const deepLinkPostId = params.get("post");
    if (!deepLinkPostId) return;

    // Remove the param from the URL without a page reload so refreshing doesn't re-trigger it.
    const cleanUrl = window.location.pathname +
      (params.toString().replace(/[&?]?post=[^&]*/g, "").replace(/^&/, "?") || "");
    window.history.replaceState(null, "", cleanUrl);

    // Fetch and open the post detail popup
    (async () => {
      try {
        const response = await postDetailsByPostId(Number(deepLinkPostId));
        if (response?.status === true) {
          setPostReviewData(response);
          setPostDetails(true);
        }
      } catch (e) {
        // If the post can't be loaded, silently ignore — the user is still on the timeline
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleMenuOpen = (event, postIndex) => {
    setMenuAnchor(event.currentTarget);
    setSelectedPost(postIndex);
  };
  const handleMenuClose = () => {
    setMenuAnchor(null);
    setSelectedPost(null);
  };

  const [engagingPostId, setEngagingPostId] = useState(null);

  const handleEngage = async (post, e) => {
    e.stopPropagation();
    if (engagingPostId) return;
    setEngagingPostId(post.id);
    try {
      const response = await engagePost(post.id);
      if (response && response.status === true && response.redirectUrl) {
        let redirectUrl = response.redirectUrl;
        if (redirectUrl.startsWith("urn:li:")) {
          redirectUrl = `https://www.linkedin.com/feed/update/${redirectUrl}`;
        }
        window.open(redirectUrl, "_blank");
        if (refreshLoyaltyPoints) {
          refreshLoyaltyPoints();
        }
      } else {
        toast.error(response?.message || "Original post is unavailable or has been removed");
      }
    } catch (error) {
      toast.error(error.message || "Original post is unavailable or has been removed");
    } finally {
      setEngagingPostId(null);
    }
  };

  const handleVisitFeatured = async (post, e) => {
    e.stopPropagation();
    if (!post?.featuredUrl || post.featuredUrl.startsWith("urn:")) return;
    try {
      const response = await visitFeaturedPost(post.id);
      let targetUrl = post.featuredUrl;
      if (response && response.status === true) {
        if (response.redirectUrl) {
          targetUrl = response.redirectUrl;
        }
        if (refreshLoyaltyPoints) {
          refreshLoyaltyPoints();
        }
      }
      window.open(targetUrl, "_blank");
    } catch (error) {
      window.open(post.featuredUrl, "_blank");
    }
  };


  const handleCardClick = (post) => {
    setClickedPost(post);
  };
  const handleNext = (postId, imagesLength) => {
    setCurrentImageIndexes((prev) => ({
      ...prev,
      [postId]:
        (prev[postId] ?? 0) === imagesLength - 1 ? 0 : (prev[postId] ?? 0) + 1,
    }));
    setActiveBunnyPlayers((prev) => {
      const next = { ...prev };
      delete next[postId];
      return next;
    });
  };

  const handlePrev = (postId, imagesLength) => {
    setCurrentImageIndexes((prev) => ({
      ...prev,
      [postId]:
        (prev[postId] ?? 0) === 0 ? imagesLength - 1 : (prev[postId] ?? 0) - 1,
    }));
    setActiveBunnyPlayers((prev) => {
      const next = { ...prev };
      delete next[postId];
      return next;
    });
  };

  const handleActivateBunnyPlayer = (postId, mediaIndex, e) => {
    e.stopPropagation();
    setActiveBunnyPlayers((prev) => ({
      ...prev,
      [postId]: mediaIndex,
    }));
  };

  const [checked, setChecked] = useState({
    Facebook: false,
    Instagram: false,
    Linkedin: false,
    "Twitter / X": false,
    WhatsApp: false,
  });

  const handleToggle = (platform) => {
    const keyMap = {
      Linkedin: "LINKEDIN",
      "Twitter / X": "X",
      Instagram: "INSTAGRAM",
      Youtube: "YOUTUBE",
      Facebook: "FACEBOOK",
      WhatsApp: "WHATSAPP",
      Internal: "INTERNAL"
    };

    const mappedKey = keyMap[platform];
    if (mappedKey && mappedKey !== "WHATSAPP" && mappedKey !== "INTERNAL") {
      const isConnected = (businessPages && Object.keys(businessPages).some(
        k => k.toUpperCase() === mappedKey
      )) || (personalConnections && personalConnections[mappedKey]);

      if (!isConnected) {
        setConnectDialogPlatform(platform);
        return;
      }
    }
    setChecked((prev) => ({
      ...prev,
      [platform]: !prev[platform],
    }));
  };

  const onClose = () => {
    setOpenDialog(false);
    setPostDetails(false);
  };

  const handleQuickShare = (post, currentVarIndex = 0) => {
    const isLinkedInConnected = (businessPages && Object.keys(businessPages).some(k => k.toUpperCase() === "LINKEDIN")) || (personalConnections && personalConnections["LINKEDIN"]);
    const isTwitterConnected = (businessPages && Object.keys(businessPages).some(k => k.toUpperCase() === "X" || k.toUpperCase() === "TWITTER")) || (personalConnections && personalConnections["X"]) || (personalConnections && personalConnections["TWITTER"]);

    if (!isLinkedInConnected && !isTwitterConnected) {
      setConnectDialogPlatform("LinkedIn / X");
      return;
    }

    setSinglePost({ ...post, _activeVariationIndex: currentVarIndex });
    const keyMap = {
      Linkedin: "LINKEDIN",
      "Twitter / X": "X",
      // Instagram: "INSTAGRAM",
      // Youtube: "YOUTUBE",
      // Facebook: "FACEBOOK",
      // WhatsApp: "WHATSAPP",
    };
    const initialChecked = {};
    Object.keys(keyMap).forEach((platformName) => {
      const mappedKey = keyMap[platformName];
      // if (mappedKey === "WHATSAPP") {
      //   initialChecked[platformName] = true;
      // } else {
      const isConnected = (businessPages && Object.keys(businessPages).some(
        k => k.toUpperCase() === mappedKey
      )) || (personalConnections && personalConnections[mappedKey]);
      initialChecked[platformName] = !!isConnected;
      // }
    });
    setChecked(initialChecked);
    setOpenDialog(true);
  };

  const handleShare = async () => {
    setShareLoading(true);
    try {
      const apiMap = {
        "Twitter / X": createXExternalPost,
        Facebook: createFacebookExternalPost,
        Instagram: createInstagramExternalPost,
        Linkedin: createLinkedinExternalPost,
        Youtube: createYoutubeExternalPost,
      };
      for (const [platform, isEnabled] of Object.entries(checked)) {
        if (isEnabled) {
          if (platform === "WhatsApp") {
            const baseText = composePlatformContent(
              getDisplayContent(singlePost?.content),
              "WhatsApp",
              businessPages,
              getSystemHashtags(singlePost)
            ).finalText;
            const textToShare = appendMediaToWhatsAppText(baseText, singlePost);
            // Share the public share-page URL so WhatsApp renders a rich preview card
            const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(textToShare)}`;
            window.open(whatsappUrl, "_blank");
            toast.success("WhatsApp shared successfully");
            setOpenDialog(false);
            continue;
          }
          const variations = getParsedVariations(singlePost?.content);
          const hasVariations = variations && variations.length > 1;
          const activeIndex = singlePost?._activeVariationIndex || 0;
          const selectedVariation = hasVariations ? variations[activeIndex] : null;
          const baseContent = getDisplayContent(singlePost?.content, activeIndex);

          const composition = composePlatformContent(
            baseContent,
            platform,
            businessPages,
            getSystemHashtags(singlePost)
          );

          if (composition.isSuffixTooLong || composition.isOverLimit) {
            toast.error(
              composition.platformKey === "x"
                ? "Exceeds X's 280 character limit. Please use ‘Share with Thoughts’ or reduce content."
                : `${platform} content exceeds the allowed character limit.`
            );
            continue;
          }

          const payload = {
            postId: singlePost?.id,
            type: "POST",
            content: composition.finalText,
          };

          if (selectedVariation?.id) {
            payload.selectedVariationId = selectedVariation.id;
          }

          // Call the correct API for that platform
          const apiFunction = apiMap[platform];
          if (apiFunction) {
            try {
              const response = await apiFunction(payload);

              if (response && response.status !== false) {
                toast.success(`${platform} post shared successfully`);
                setOpenDialog(false);
              } else {
                toast.error(formatPlatformErrorMessage(response?.message || `${platform} post failed`, platform));
              }
            } catch (platformErr) {
              toast.error(formatPlatformErrorMessage(platformErr.message || `${platform} post failed`, platform));
            }
          }
        }
      }
    } catch (error) {
      console.error(error, "error");
      toast.error(error.message || "Something went wrong while sharing the post");
    } finally {
      setShareLoading(false);
    }
  };

  const handleShareWithThoughts = async (post, e, currentVarIndex = 0) => {
    e.stopPropagation();
    // const isLinkedInConnected = (businessPages && Object.keys(businessPages).some(k => k.toUpperCase() === "LINKEDIN")) || (personalConnections && personalConnections["LINKEDIN"]);
    // const isTwitterConnected = (businessPages && Object.keys(businessPages).some(k => k.toUpperCase() === "X" || k.toUpperCase() === "TWITTER")) || (personalConnections && personalConnections["X"]) || (personalConnections && personalConnections["TWITTER"]);
    const isLinkedInConnected = personalConnections && personalConnections["LINKEDIN"];
    const isTwitterConnected = personalConnections && (personalConnections["X"] || personalConnections["TWITTER"]);
    if (!isLinkedInConnected && !isTwitterConnected) {
      setConnectDialogPlatform("LinkedIn / X");
      return;
    }

    await prepareThePost(post?.id);
    setSharePopupVariationIndex(currentVarIndex);
    setOpenSharePopup(true);
  };

  const handleClose = () => {
    setOpenSharePopup(false);
    setPostReviewData(null);
    fetchAllPosts();
  };

  const handleDetails = async (id, e) => {
    e.stopPropagation();
    setPostReviewData(null);
    try {
      // setLoadingPostId(id);
      const response = await postDetailsByPostId(id);
      if (response?.status === true) {
        setPostDetails(true);
        setPostReviewData(response);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingPostId(null);
    }
  };
  const prepareThePost = async (id) => {
    setPostReviewData(null);
    try {
      setLoadingPostId(id);
      const response = await preparePost(`${id}?isShare=true`);
      if (response?.status === true) {
        setPostReviewData(response);
        await summaryThePost(id);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingPostId(null);
    }
  };

  const summaryThePost = async (id) => {
    try {
      const payload = {
        postId: id,
      };
      // const response = await postSummary(payload);
      // if (response?.status === true) {
      //   setSummary(response?.generateContentResponseDTO?.summarizedContent);
      // }
    } catch (error) {
      console.log(error);
    }
  };

  const handleOpenSettings = (post, e) => {
    e.stopPropagation();
    setSettingsPost(post);
    setSettingsAllowEdit(!!post?.allowEdit);
    setSettingsCategories(post?.categories?.map((c) => c.categoryId) || []);
    setDeleteConfirm(false);
    setOpenSettingsDialog(true);
  };

  const handleSaveSettings = async () => {
    setSettingsSaving(true);
    try {
      const response = await updatePostSettings(settingsPost.id, {
        allowEdit: settingsAllowEdit,
        categoryIds: settingsCategories,
      });
      if (response?.status) {
        toast.success("Post settings saved");
        setOpenSettingsDialog(false);
        fetchAllPosts(0);
      } else {
        toast.error("Failed to save settings");
      }
    } catch (err) {
      toast.error(err.message || "Failed to save settings");
    } finally {
      setSettingsSaving(false);
    }
  };

  const handleDeletePost = async () => {
    setSettingsSaving(true);
    try {
      const response = await deletePost(settingsPost.id);
      if (response?.status) {
        toast.success("Post deleted");
        setOpenSettingsDialog(false);
        fetchAllPosts(0);
      } else {
        toast.error("Failed to delete post");
      }
    } catch (err) {
      toast.error(err.message || "Failed to delete post");
    } finally {
      setSettingsSaving(false);
    }
  };

  const handleOpenEditPost = () => {
    setOpenSettingsDialog(false);
    if (onEditPost) onEditPost(settingsPost);
  };

  const handleDeleteFeaturedPost = async () => {
    setSettingsSaving(true);
    try {
      const response = await deletePost(featuredDeletePost.id);
      if (response?.status) {
        toast.success("Post deleted");
        setFeaturedDeletePost(null);
        fetchAllPosts(0);
      } else {
        toast.error("Failed to delete post");
      }
    } catch (err) {
      toast.error(err.message || "Failed to delete post");
    } finally {
      setSettingsSaving(false);
    }
  };

  // const fetchAllPosts = async () => {
  //   try {
  //     const payload = {
  //       category: id,
  //       platform: selected.toUpperCase(),
  //       search: categoryList?.searchValue,
  //     };
  //     const response = await getPosts(payload, page, limit);
  //     if (response?.status) {
  //       setPostsList(response?.posts);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   } finally {
  //   }
  // };
  const fetchAllPosts = async (newPage = 0) => {
    try {
      setLoading(true);
      const payload = {
        category: selectedCategory?.id || id || "",
        platform: selectedPlatform,
        search: categoryList?.searchValue,
      };
      const response = await getPosts(payload, newPage, limit);

      if (response?.status) {
        let newPosts = response?.posts || [];
        if (isPayoneerSubdomain()) {
          if (!selectedPlatform) {
            newPosts = newPosts.filter((p) => isCreatedContentPost(p));
          } else {
            newPosts = newPosts.filter((p) => {
              const type = (p?.type || "").toUpperCase();
              const srcType = (p?.sourceType || "").toUpperCase();
              return !["INSTAGRAM", "YOUTUBE", "FACEBOOK"].includes(type) &&
                !["INSTAGRAM", "YOUTUBE", "FACEBOOK"].includes(srcType);
            });
          }
        }
        if (newPage === 0) {
          setPostsList(newPosts);
        } else {
          setPostsList((prev) => [...prev, ...newPosts]);
        }
        setHasMore(newPosts.length === limit);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    setPostsList([]);
    setPage(0);
    fetchAllPosts(0);
  }, [
    categoryList?.categoriesDetails,
    categoriesData,
    selectedCategory,
    selectedPlatform,
    location,
    categoryList?.searchValue,
    refreshFeed,
  ]);
  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + window.scrollY >=
        document.body.offsetHeight - 100
      ) {
        if (!loading && hasMore) {
          const nextPage = page + 1;
          setPage(nextPage);
          fetchAllPosts(nextPage);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [page, hasMore, loading]);

  // useEffect(() => {
  //   fetchAllPosts();
  // }, [
  //   categoryList?.categoriesDetails,
  //   selected,
  //   location,
  //   categoryList?.searchValue,
  // ]);
  const clear = () => { };
  return (
    <>
      {postReviewData && postDetails && (
        <PostDetails
          open={postDetails}
          postReviewData={postReviewData}
          onClose={onClose}
        />
      )}

      {openSharePopup && postReviewData && (
        <SharePostPopup
          open={openSharePopup}
          title="Share Post"
          type="share"
          selected={"All"}
          onClose={handleClose}
          clear={clear}
          postReviewData={postReviewData}
          summary={summary}
          personalConnections={personalConnections}
          initialVariationIndex={sharePopupVariationIndex}
        />
      )}
      <Box
        sx={{
          backgroundColor: "#FFFFFF",
          padding: "8px 12px",
          borderRadius: "16px",
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: { md: "space-between" },
          alignItems: { xs: "stretch", md: "center" },
          gap: "8px",
        }}
      >
        {/* Row 1 — Category tabs (scrollable) */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            overflowX: "auto",
            "::-webkit-scrollbar": { display: "none" },
            flex: { md: 1 },
            minWidth: 0,
          }}
        >
          <Button
            key="all"
            onClick={() => { setSelectedCategory(null); setSelectedPlatform(""); }}
            disableRipple
            sx={{
              textTransform: "none",
              fontWeight: selectedCategory === null ? 500 : 400,
              fontSize: "13px",
              color: selectedCategory === null ? "#fff" : "#95919D",
              backgroundColor: selectedCategory === null ? "#003db3" : "transparent",
              borderRadius: "8px",
              padding: "6px 14px",
              minWidth: "auto",
              flexShrink: 0,
              "&:hover": {
                backgroundColor: selectedCategory === null ? "#003db3" : "#f4f4f4",
              },
            }}
          >
            All
          </Button>
          <Button
            key="featured"
            onClick={() => { setSelectedCategory(featuredCategory); setSelectedPlatform(""); }}
            disableRipple
            startIcon={<StarIcon sx={{ fontSize: "14px !important", color: "inherit" }} />}
            sx={{
              textTransform: "none",
              fontWeight: selectedCategory?.id === featuredCategory?.id && selectedCategory !== null ? 500 : 400,
              fontSize: "13px",
              color: selectedCategory?.id === featuredCategory?.id && selectedCategory !== null ? "#fff" : "#B8860B",
              backgroundColor:
                selectedCategory?.id === featuredCategory?.id && selectedCategory !== null
                  ? "#B8860B"
                  : "transparent",
              borderRadius: "8px",
              padding: "6px 14px",
              minWidth: "auto",
              flexShrink: 0,
              border: "1px solid #FFD700",
              "&:hover": {
                backgroundColor:
                  selectedCategory?.id === featuredCategory?.id && selectedCategory !== null
                    ? "#996e0a"
                    : "#FFF8E1",
              },
            }}
          >
            Featured
          </Button>
          {categoriesData?.filter((c) => c.name?.toLowerCase() !== "featured").map((category) => (
            <Button
              key={category.id}
              onClick={() => { setSelectedCategory(category); setSelectedPlatform(""); }}
              disableRipple
              sx={{
                textTransform: "none",
                fontWeight: selectedCategory?.id === category.id ? 500 : 400,
                fontSize: "13px",
                color: selectedCategory?.id === category.id ? "#fff" : "#95919D",
                backgroundColor:
                  selectedCategory?.id === category.id ? "#003db3" : "transparent",
                borderRadius: "8px",
                padding: "6px 14px",
                minWidth: "auto",
                flexShrink: 0,
                "&:hover": {
                  backgroundColor:
                    selectedCategory?.id === category.id ? "#003db3" : "#f4f4f4",
                },
              }}
            >
              {category.name}
            </Button>
          ))}
        </Box>

        {/* Row 2 — Platform icon tabs (right-aligned) */}
        <Box sx={{ display: "flex", alignItems: "center", gap: "4px", justifyContent: "flex-end", flexShrink: 0 }}>
          {[
            { key: "LINKEDIN", icon: LinkedInIcon, label: "LinkedIn" },
            { key: "X", icon: TwitterIcon, label: "X" },
            { key: "INSTAGRAM", icon: InstagramIcon, label: "Instagram" },
            { key: "YOUTUBE", icon: youtube, label: "YouTube" },
            { key: "FACEBOOK", icon: FacebookIcon, label: "Facebook" },
          ].filter(({ key }) => !isDisallowedPayoneerPlatform(key)).map(({ key, icon, label }) => (
            <Tooltip title={label} key={key} arrow>
              <IconButton
                onClick={() => { setSelectedPlatform((prev) => prev === key ? "" : key); setSelectedCategory(null); }}
                disableRipple
                sx={{
                  width: { xs: 36, md: 32 },
                  height: { xs: 36, md: 32 },
                  borderRadius: "8px",
                  padding: "5px",
                  backgroundColor: selectedPlatform === key ? "#EEF2FF" : "transparent",
                  border: selectedPlatform === key ? "1.5px solid #003db3" : "1.5px solid transparent",
                  "&:hover": { backgroundColor: "#f4f4f4" },
                }}
              >
                <Box component="img" src={icon} alt={label} sx={{ width: { xs: 22, md: 18 }, height: { xs: 22, md: 18 }, borderRadius: "3px" }} />
              </IconButton>
            </Tooltip>
          ))}
        </Box>

      </Box>
      <Box mt={2} className="postCard-container" sx={{ position: "relative", minHeight: 200 }}>
        {loading && postsList.length === 0 && (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(255,255,255,0.8)",
              zIndex: 10,
              borderRadius: 2,
            }}
          >
            <CircularProgress size={36} />
          </Box>
        )}
        <Grid container spacing={{ xs: 0, md: 1.2 }}>
          {(() => {
            const visiblePosts = isPayoneerSubdomain()
              ? postsList.filter((p) => {
                const type = (p?.type || "").toUpperCase();
                const srcType = (p?.sourceType || "").toUpperCase();
                if (!selectedPlatform) {
                  return isCreatedContentPost(p);
                }
                return !["INSTAGRAM", "YOUTUBE", "FACEBOOK"].includes(type) &&
                  !["INSTAGRAM", "YOUTUBE", "FACEBOOK"].includes(srcType);
              })
              : postsList;

            if (visiblePosts?.length > 0) {
              const firstShareableIndex = visiblePosts.findIndex(
                (p) => p?.categories?.length > 0 && p.categories.some((cat) => cat.shareEnabled === true) && !p?.featuredUrl
              );

              return visiblePosts.map((post, index) => {
                const variations = getParsedVariations(post?.content);
                const hasVariations = variations && variations.length > 1;
                const currentVarIndex = currentVariationIndexes[post?.id] || 0;
                const displayContent = getDisplayContent(post?.content, currentVarIndex);

                // Feed already returns complete media (with variationId) — filter by active variation
                let currentMediaItems = post?.media || [];
                if (hasVariations) {
                  const selectedVar = variations[currentVarIndex];
                  const allMedia = post?.media || [];
                  const hasVariationId = allMedia.some((m) => m?.variationId);
                  if (hasVariationId) {
                    currentMediaItems = allMedia.filter(
                      (m) => m?.variationId === selectedVar?.id
                    );
                  } else {
                    let offset = 0;
                    for (let i = 0; i < variations.length; i++) {
                      const count =
                        (variations[i].libraryMediaIds?.length || 0) +
                        (variations[i].mediaIds?.length || 0);
                      if (i === currentVarIndex) {
                        currentMediaItems =
                          count > 0 ? allMedia.slice(offset, offset + count) : [];
                        break;
                      }
                      offset += count;
                    }
                  }
                }

                return (
                  <Grid item xs={12} sm={6} md={6} lg={4} key={post?.id} sx={{ pb: { xs: 1.5, md: 0 } }}>
                    <Card
                      className="postCard"
                      onClick={() => handleCardClick(post)}
                      elevation={0}
                      sx={{
                        height: { md: "500px" },
                        display: "flex",
                        flexDirection: "column",
                        position: "relative",
                      }}
                    >
                      {/* Settings Icon - admin only, non-featured posts */}
                      {isAdmin && (!post?.featuredUrl || post.featuredUrl.startsWith("urn:")) && (
                        <IconButton
                          sx={{
                            position: "absolute",
                            top: 8,
                            right: 8,
                            zIndex: 1,
                            width: "28px",
                            height: "28px",
                            backgroundColor: "#F4F0FF",
                            "&:hover": { backgroundColor: "#EDE9FE" },
                          }}
                          onClick={(e) => handleOpenSettings(post, e)}
                        >
                          <SettingsIcon sx={{ color: "#2563EB", width: "16px", height: "16px" }} />
                        </IconButton>
                      )}
                      {/* Delete (×) button - admin only, featured posts */}
                      {isAdmin && post?.featuredUrl && !post.featuredUrl.startsWith("urn:") && (
                        <IconButton
                          sx={{
                            position: "absolute",
                            top: 8,
                            right: 8,
                            zIndex: 1,
                            width: "28px",
                            height: "28px",
                            backgroundColor: "#FEF2F2",
                            "&:hover": { backgroundColor: "#FEE2E2" },
                          }}
                          onClick={(e) => { e.stopPropagation(); setFeaturedDeletePost(post); }}
                        >
                          <CloseIcon sx={{ color: "#DC2626", width: "16px", height: "16px" }} />
                        </IconButton>
                      )}
                      <CardHeader
                        sx={{ padding: "14px 10px 5px !important" }}
                        avatar={
                          <Box sx={{ position: "relative", display: "inline-block" }}>
                            <Avatar
                              variant="rounded"
                              src={getDisplayAvatar(post, userProfile)}
                              alt={getDisplayName(post)}
                              imgProps={{ style: { objectFit: "contain", padding: "2px" } }}
                              sx={{
                                width: 36,
                                height: 36,
                                borderRadius: "8px",
                                backgroundColor: "#ffffff",
                                border: "1px solid #E2E8F0",
                              }}
                            />
                            {getPlatformIcon(post) ? (
                              <Box
                                component="img"
                                src={getPlatformIcon(post)}
                                alt={getPlatformLabel(post)}
                                sx={{
                                  width: 14,
                                  height: 14,
                                  position: "absolute",
                                  bottom: -2,
                                  right: -2,
                                  borderRadius: "50%",
                                  backgroundColor: "#fff",
                                  border: "1px solid #E2E8F0",
                                  padding: "1px",
                                }}
                              />
                            ) : null}
                          </Box>
                        }
                        action={
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <Typography
                              color="#D5D5D5"
                              fontSize={"14px"}
                              sx={{ mr: 1 }}
                            >
                              {getTimeAgo(post?.platformCreatedAt || post?.createdAt)}
                            </Typography>
                          </Box>
                        }
                        title={
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <span>{getDisplayName(post)}</span>
                          </Box>
                        }
                        subheader={
                          <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap", mt: 0.25 }}>
                            {getDisplayUsername(post) ? (
                              <Typography
                                component="span"
                                sx={{ color: "#6B7280", fontSize: "12px", fontWeight: 400 }}
                              >
                                {getDisplayUsername(post)}
                              </Typography>
                            ) : null}
                            {post?.createdBy?.teamName ? (
                              <Typography
                                component="span"
                                sx={{
                                  color: "#95919D",
                                  fontSize: { xs: "11px", sm: "13px", md: "12px" },
                                  fontWeight: 400,
                                }}
                              >
                                {post.createdBy.teamName}
                              </Typography>
                            ) : null}
                            {getSourceLabel(post) ? (
                              <Chip
                                size="small"
                                label={getSourceLabel(post)}
                                sx={{
                                  height: 20,
                                  fontSize: "10px",
                                  fontWeight: 600,
                                  backgroundColor:
                                    post?.sourceType === "LEADER_PROFILE" ? "#EEF2FF" : "#ECFDF3",
                                  color:
                                    post?.sourceType === "LEADER_PROFILE" ? "#3730A3" : "#166534",
                                }}
                              />
                            ) : null}
                          </Box>
                        }
                        titleTypographyProps={{
                          onClick: (e) => handleDetails(post?.id, e),
                          sx: {
                            color: "#3B3B3B",
                            fontWeight: 500,
                            cursor: "pointer",
                            // fontSize: "18px",
                            fontSize: { xs: "12px", sm: "14px", md: "13px" },
                          },
                        }}
                      />
                      <CardContent
                        sx={{
                          padding: "0px 11px 16px 11px !important",
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                          overflow: "hidden",
                          minHeight: 0,
                        }}
                      >
                        <Box
                          className="custom-scrollbar"
                          sx={{
                            flex: 1,
                            overflowY: "auto",
                            overflowX: "hidden",
                            display: "flex",
                            flexDirection: "column",
                            pr: 0.5,
                            // Custom scrollbar styling
                            "&::-webkit-scrollbar": {
                              width: "4px",
                            },
                            "&::-webkit-scrollbar-thumb": {
                              backgroundColor: "#e0e0e0",
                              borderRadius: "10px",
                            },
                            "&::-webkit-scrollbar-track": {
                              backgroundColor: "transparent",
                            },
                          }}
                        >
                          <Box>
                            {hasVariations && (
                              <Box display="flex" justifyContent="space-between" alignItems="center" mb={1} mt={0.5}>
                                <Typography variant="caption" sx={{ color: "#0047AB", fontWeight: 600, backgroundColor: "#E7F1FF", px: 1, py: 0.5, borderRadius: 1 }}>
                                  Variation {currentVarIndex + 1} of {variations.length}
                                </Typography>
                                <Box display="flex" gap={0.5}>
                                  <IconButton
                                    size="small"
                                    onClick={(e) => handleVariationChange(post?.id, -1, variations.length, e)}
                                    sx={{ backgroundColor: "#f4f4f4", width: 24, height: 24, "&:hover": { backgroundColor: "#e0e0e0" } }}
                                  >
                                    <ChevronLeftIcon sx={{ fontSize: 16 }} />
                                  </IconButton>
                                  <IconButton
                                    size="small"
                                    onClick={(e) => handleVariationChange(post?.id, 1, variations.length, e)}
                                    sx={{ backgroundColor: "#f4f4f4", width: 24, height: 24, "&:hover": { backgroundColor: "#e0e0e0" } }}
                                  >
                                    <ChevronRightIcon sx={{ fontSize: 16 }} />
                                  </IconButton>
                                </Box>
                              </Box>
                            )}
                            {/* <Tooltip title={displayContent} arrow>
                            <div> */}
                            <FormatPostContent
                              content={displayContent}
                              TypographyProps={{
                                color: "#5D5D5D",
                                fontWeight: 400,
                                onClick: (e) => handleDetails(post?.id, e),
                                sx: {
                                  fontSize: { xs: "12px", sm: "14px", md: "12px" },
                                  lineHeight: 1.3,
                                  cursor: "pointer",
                                  wordBreak: "break-word",
                                },
                                style: (currentMediaItems?.length > 0 || (post?.featuredUrl && !post.featuredUrl.startsWith("urn:"))) ? {
                                  display: "-webkit-box",
                                  WebkitLineClamp: 2,
                                  WebkitBoxOrient: "vertical",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis"
                                } : {
                                  display: "block"
                                },
                                gutterBottom: true,
                                mb: 1.5,
                              }}
                            />
                            {/* </div>
                          </Tooltip> */}
                          </Box>

                          {currentMediaItems?.length > 0 && (
                            <Box
                              position="relative"
                              borderRadius="8px"
                              overflow="hidden"
                            >
                              {currentMediaItems
                                .slice(
                                  currentImageIndexes?.[post?.id] ?? 0,
                                  (currentImageIndexes?.[post?.id] ?? 0) + 1
                                )
                                .map((mediaItem, index) => {
                                  const currentMediaIndex =
                                    currentImageIndexes?.[post?.id] ?? 0;
                                  const isActiveBunnyPlayer =
                                    activeBunnyPlayers?.[post?.id] ===
                                    currentMediaIndex;

                                  return mediaItem?.mediaType?.toUpperCase() === "IMAGE" ? (
                                    <CardMedia
                                      key={index}
                                      onClick={(e) => handleDetails(post?.id, e)}
                                      component="img"
                                      image={getResolvedImageUrl(mediaItem, noImage)}
                                      sx={{
                                        height: { md: "280px" },
                                        width: "100%",
                                        objectFit: "cover",
                                        borderRadius: "8px",
                                        cursor: "pointer",
                                      }}
                                    />
                                  ) : mediaItem?.mediaType?.toUpperCase() === "VIDEO" ? (
                                    <Box
                                      key={index}
                                      sx={{
                                        position: "relative",
                                        height: { md: "280px" },
                                        width: "100%",
                                        borderRadius: "8px",
                                        overflow: "hidden",
                                      }}
                                      onClick={(e) => handleDetails(post?.id, e)}
                                    >
                                      {isBunnyStreamMedia(mediaItem) ? (
                                        isActiveBunnyPlayer ? (
                                          <iframe
                                            src={getBunnyEmbedUrl(
                                              getResolvedVideoUrl(mediaItem),
                                              { autoplay: true }
                                            )}
                                            title={post?.title || "Timeline video"}
                                            style={{
                                              height: "100%",
                                              width: "100%",
                                              border: 0,
                                              display: "block",
                                              borderRadius: "8px",
                                            }}
                                            allow="accelerometer; gyroscope; encrypted-media; picture-in-picture;"
                                            allowFullScreen
                                          />
                                        ) : (
                                          <>
                                            <CardMedia
                                              component="img"
                                              image={getResolvedPosterUrl(mediaItem, BLACK_THUMBNAIL)}
                                              onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = BLACK_THUMBNAIL;
                                              }}
                                              sx={{
                                                height: "100%",
                                                width: "100%",
                                                objectFit: "cover",
                                                borderRadius: "8px",
                                                cursor: "pointer",
                                              }}
                                            />
                                            <IconButton
                                              onClick={(e) =>
                                                handleActivateBunnyPlayer(
                                                  post?.id,
                                                  currentMediaIndex,
                                                  e
                                                )
                                              }
                                              sx={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)",
                                                backgroundColor: "rgba(0,0,0,0.55)",
                                                color: "#fff",
                                                "&:hover": {
                                                  backgroundColor:
                                                    "rgba(0,0,0,0.7)",
                                                },
                                              }}
                                            >
                                              <PlayArrowIcon />
                                            </IconButton>
                                          </>
                                        )
                                      ) : (
                                        <video
                                          src={`${getResolvedVideoUrl(mediaItem)}#t=0.1`}
                                          poster={mediaItem?.thumbnailUrl && mediaItem.thumbnailUrl !== BLACK_THUMBNAIL ? mediaItem.thumbnailUrl : undefined}
                                          style={{
                                            height: "100%",
                                            width: "100%",
                                            objectFit: "cover",
                                            borderRadius: "8px",
                                            cursor: "pointer",
                                            background: "#000",
                                          }}
                                          controls referrerPolicy="no-referrer"
                                          preload="metadata"
                                        />
                                      )}
                                    </Box>
                                  ) : (
                                    <Box
                                      key={index}
                                      sx={{
                                        position: "relative",
                                        height: { xs: "250px", md: "280px" },
                                        width: "100%",
                                        borderRadius: "8px",
                                        overflow: "hidden",
                                        backgroundColor: "#f8fafc",
                                        border: "1px solid #BFDBFE",
                                      }}
                                    >
                                      {mediaItem?.fileUrl ? (
                                        <>
                                          <iframe
                                            src={
                                              mediaItem.fileUrl.toLowerCase().endsWith(".pdf") || mediaItem.fileUrl.startsWith("blob:")
                                                ? `${mediaItem.fileUrl}#toolbar=0&navpanes=0&scrollbar=0`
                                                : `https://docs.google.com/viewer?url=${encodeURIComponent(mediaItem.fileUrl)}&embedded=true`
                                            }
                                            title={mediaItem.fileName || "Document Preview"}
                                            style={{
                                              width: "calc(100% + 15px)",
                                              height: "calc(100% + 55px)",
                                              border: 0,
                                              position: "absolute",
                                              top: 0,
                                              left: 0,
                                            }}
                                          />
                                          <IconButton
                                            component="a"
                                            href={mediaItem.fileUrl}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            onClick={(e) => e.stopPropagation()}
                                            sx={{
                                              position: "absolute",
                                              top: 10,
                                              right: 10,
                                              backgroundColor: "rgba(255,255,255,0.9)",
                                              boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                                              "&:hover": { backgroundColor: "#ffffff" },
                                              zIndex: 3,
                                            }}
                                            size="small"
                                          >
                                            <OpenInNewIcon sx={{ color: "#1D4ED8", fontSize: 18 }} />
                                          </IconButton>
                                        </>
                                      ) : (
                                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", p: 2 }}>
                                          <Typography sx={{ fontSize: 13, color: "#1D4ED8", fontWeight: 500 }}>
                                            📄 {mediaItem?.fileName || "Document"}
                                          </Typography>
                                        </Box>
                                      )}
                                    </Box>
                                  );
                                })}
                              {/* <CardMedia
                          onClick={(e) => handleDetails(post?.id, e)}
                          component="img"
                          image={
                            post?.media?.length > 0 &&
                            post?.media?.[currentImageIndexes?.[post?.id] ?? 0]
                              ?.fileUrl
                              ? post?.media?.[
                                  currentImageIndexes?.[post?.id] ?? 0
                                ]?.fileUrl
                              : noImage
                          }
                          // alt={`Image ${post?.content}`}
                          sx={{
                            height: { md: "280px" },
                            width: "100%",
                            objectFit: "cover",
                            borderRadius: "8px",
                            cursor: "pointer",
                          }}
                        /> */}

                              {currentMediaItems?.length > 1 && (
                                <>
                                  <IconButton
                                    onClick={() =>
                                      handlePrev(post?.id, currentMediaItems?.length)
                                    }
                                    sx={{
                                      position: "absolute",
                                      top: "50%",
                                      left: 8,
                                      width: "30px",
                                      height: "30px",
                                      transform: "translateY(-50%)",
                                      backgroundColor: "rgba(0,0,0,0.4)",
                                      color: "#fff",
                                      "&:hover": {
                                        backgroundColor: "rgba(0,0,0,0.6)",
                                      },
                                      zIndex: 4,
                                    }}
                                  >
                                    <ChevronLeftIcon />
                                  </IconButton>

                                  <IconButton
                                    onClick={() =>
                                      handleNext(post?.id, currentMediaItems?.length)
                                    }
                                    sx={{
                                      position: "absolute",
                                      top: "50%",
                                      right: 8,
                                      width: "30px",
                                      height: "30px",
                                      transform: "translateY(-50%)",
                                      backgroundColor: "rgba(0,0,0,0.4)",
                                      color: "#fff",
                                      "&:hover": {
                                        backgroundColor: "rgba(0,0,0,0.6)",
                                      },
                                      zIndex: 4,
                                    }}
                                  >
                                    <ChevronRightIcon />
                                  </IconButton>
                                  <Box
                                    sx={{
                                      position: "absolute",
                                      bottom: 12,
                                      left: "50%",
                                      transform: "translateX(-50%)",
                                      display: "flex",
                                      gap: 1,
                                      zIndex: 4,
                                    }}
                                  >
                                    {currentMediaItems?.map((_, index) => (
                                      <Box
                                        key={index}
                                        sx={{
                                          width: 8,
                                          height: 8,
                                          borderRadius: "50%",
                                          backgroundColor:
                                            index ===
                                              (currentImageIndexes[post.id] ?? 0)
                                              ? "primary.main"
                                              : "rgba(255, 255, 255, 0.7)",
                                          boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
                                        }}
                                      />
                                    ))}
                                  </Box>
                                </>
                              )}
                            </Box>
                          )}

                          {post?.featuredUrl && !post.featuredUrl.startsWith("urn:") && (
                            <Box mt={1.5} flex={1}>
                              <LinkPreview url={post.featuredUrl} />
                            </Box>
                          )}
                        </Box>

                        <Box sx={{ mt: "auto", pt: 2, flexShrink: 0 }}>
                          {(() => {
                            const isShareEnabled = post?.categories && post.categories.length > 0
                              ? post.categories.some((cat) => cat.shareEnabled === true)
                              : false;
                            const isExternalPlatformPost = !!(post?.type && PLATFORM_ICON_MAP[post?.type?.toUpperCase()]);

                            if (post?.featuredUrl && !post.featuredUrl.startsWith("urn:") && !isExternalPlatformPost) {
                              return (
                                <Button
                                  onClick={(e) => handleVisitFeatured(post, e)}
                                  startIcon={<OpenInNewIcon sx={{ fontSize: "15px !important" }} />}
                                  fullWidth
                                  sx={{
                                    textTransform: "none",
                                    fontWeight: 500,
                                    fontSize: { xs: "12px", sm: "13px", md: "12px" },
                                    color: "#fff",
                                    backgroundColor: "#B45309",
                                    borderRadius: "10px",
                                    padding: "10px 14px",
                                    "&:hover": { backgroundColor: "#92400E" },
                                  }}
                                >
                                  Visit Featured Post
                                </Button>
                              );
                            }

                            if (isShareEnabled) {
                              return (
                                <Box
                                  id={index === firstShareableIndex ? "onboarding-share-post-btn" : undefined}
                                  sx={{ display: "flex", flexDirection: "column", gap: { xs: 1, md: 0.7 }, width: "100%" }}
                                >
                                  {/* Row 1: Share with Thoughts — full width */}
                                  <Tooltip
                                    title={!post?.allowEdit ? "Admin has not enabled caption editing for this post" : ""}
                                    disableHoverListener={!!post?.allowEdit}
                                    arrow
                                  >
                                    <Box
                                      component="span"
                                      className="share-thoughts-btn"
                                      sx={{ display: "block", width: "100%" }}
                                    >
                                      <Button
                                        startIcon={<img src={edit} alt="edit" style={{ width: "15px", height: "15px" }} />}
                                        sx={{
                                          textTransform: "none",
                                          fontWeight: 400,
                                          fontSize: { xs: "10px", sm: "11px", md: "11px" },
                                          color: "#0047AB",
                                          borderColor: "#f1efff",
                                          width: "100%",
                                          backgroundColor: "#F4F0FF",
                                          borderRadius: "10px",
                                          padding: { xs: "8px 4px", sm: "8px 6px", md: "8px 6px", lg: "8px 8px" },
                                          justifyContent: "center",
                                          "&:hover": { backgroundColor: "#f1efff", borderColor: "#f1efff" },
                                        }}
                                        onClick={(e) => handleShareWithThoughts(post, e, currentVariationIndexes[post?.id] || 0)}
                                        disabled={loadingPostId === post?.id || !post?.allowEdit}
                                      >
                                        {loadingPostId === post?.id ? <CircularProgress size={20} color="inherit" /> : "Share with Thoughts"}
                                      </Button>
                                    </Box>
                                  </Tooltip>

                                  {/* Row 2: Quick Share + WhatsApp side by side */}
                                  <Box sx={{ display: "grid", gridTemplateColumns: isPayoneerSubdomain(businessPages) ? "1fr" : "1fr 1fr", gap: { xs: 1, md: 0.7 } }}>
                                    <Button
                                      onClick={() => handleQuickShare(post, currentVariationIndexes[post?.id] || 0)}
                                      startIcon={<img src={share} alt="share" style={{ width: "14px", height: "14px" }} />}
                                      sx={{
                                        textTransform: "none",
                                        fontWeight: 400,
                                        fontSize: { xs: "10px", sm: "11px", md: "11px" },
                                        backgroundColor: "#003db3",
                                        borderRadius: "10px",
                                        width: "100%",
                                        color: "#fff",
                                        padding: { xs: "10px 4px", sm: "8px 6px", md: "8px 6px", lg: "8px 8px" },
                                        justifyContent: "center",
                                        "&:hover": { backgroundColor: "#002e80" },
                                      }}
                                    >
                                      Quick Share
                                    </Button>
                                    {!isPayoneerSubdomain(businessPages) && (
                                      <Button
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          const currentVarIndex = currentVariationIndexes[post?.id] || 0;
                                          const variations = getParsedVariations(post?.content);
                                          const hasVariations = variations && variations.length > 1;
                                          const selectedVariation = hasVariations ? variations[currentVarIndex] : null;
                                          const activePost = selectedVariation ? { ...post, media: currentMediaItems } : post;
                                          const activeContent = getDisplayContent(post?.content, currentVarIndex);
                                          const baseText = composePlatformContent(activeContent, "WhatsApp", businessPages, getSystemHashtags(activePost)).finalText;
                                          const textToShare = appendMediaToWhatsAppText(baseText, activePost);
                                          // Share the public share-page URL so WhatsApp renders a rich preview card
                                          const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(textToShare)}`;
                                          window.open(whatsappUrl, "_blank");
                                          toast.success("WhatsApp shared successfully");
                                        }}
                                        startIcon={<img src={whatsapp} alt="whatsapp" style={{ width: "16px", height: "16px", filter: "brightness(0) invert(1)" }} />}
                                        sx={{
                                          textTransform: "none",
                                          fontWeight: 400,
                                          fontSize: { xs: "10px", sm: "11px", md: "11px" },
                                          backgroundColor: "#25D366",
                                          borderRadius: "10px",
                                          width: "100%",
                                          color: "#fff",
                                          padding: { xs: "8px 4px", sm: "8px 6px", md: "8px 6px", lg: "8px 8px" },
                                          justifyContent: "center",
                                          "&:hover": { backgroundColor: "#128C7E" },
                                        }}
                                      >
                                        WhatsApp
                                      </Button>
                                    )}
                                  </Box>

                                  {/* Row 3: Engage — only for external platform posts */}
                                  {isExternalPlatformPost && (
                                    <Button
                                      onClick={(e) => handleEngage(post, e)}
                                      disabled={engagingPostId === post?.id}
                                      startIcon={
                                        engagingPostId === post?.id ? (
                                          <CircularProgress size={14} color="inherit" />
                                        ) : (
                                          <OpenInNewIcon sx={{ fontSize: "14px !important" }} />
                                        )
                                      }
                                      sx={{
                                        textTransform: "none",
                                        fontWeight: 400,
                                        fontSize: { xs: "10px", sm: "11px", md: "11px" },
                                        backgroundColor: "#F1F5F9",
                                        color: "#475569",
                                        borderRadius: "10px",
                                        width: "100%",
                                        padding: { xs: "6px 4px", sm: "8px 6px", md: "8px 6px", lg: "8px 8px" },
                                        justifyContent: "center",
                                        "&:hover": { backgroundColor: "#E2E8F0" },
                                      }}
                                    >
                                      Engage
                                    </Button>
                                  )}
                                </Box>
                              );
                            } else {
                              return isExternalPlatformPost ? (
                                <Button
                                  onClick={(e) => handleEngage(post, e)}
                                  disabled={engagingPostId === post?.id}
                                  startIcon={
                                    engagingPostId === post?.id ? (
                                      <CircularProgress size={16} color="inherit" />
                                    ) : (
                                      <OpenInNewIcon sx={{ fontSize: "15px !important" }} />
                                    )
                                  }
                                  fullWidth
                                  sx={{
                                    textTransform: "none",
                                    fontWeight: 500,
                                    fontSize: { xs: "12px", sm: "13px", md: "12px" },
                                    color: "#fff",
                                    backgroundColor: "#003db3",
                                    borderRadius: "10px",
                                    padding: "10px 14px",
                                    "&:hover": { backgroundColor: "#002f8c" },
                                  }}
                                >
                                  Engage
                                </Button>
                              ) : null;
                            }
                          })()}
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                );
              });
            }
            return (
              <Box
                display={"flex"}
                justifyContent={"center"}
                width={"100%"}
                mt={5}
                height={"100px"}
              >
                <Typography variant="body2" align="center" color="#95919D">
                  No posts found.
                </Typography>
              </Box>
            );
          })()}
        </Grid>
        {loading && (
          <Box textAlign="center" mt={2}>
            <CircularProgress size={24} />
          </Box>
        )}
        {/* Menu for Edit/Delete */}
        <Menu
          anchorEl={menuAnchor}
          open={Boolean(menuAnchor)}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <MenuItem onClick={() => alert(`Edit Post #${selectedPost + 1}`)}>
            Edit
          </MenuItem>
          <MenuItem onClick={() => alert(`Delete Post #${selectedPost + 1}`)}>
            Delete
          </MenuItem>
        </Menu>
      </Box>

      <PostDailog
        isOpen={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        post={clickedPost}
      />

      <Dialog
        open={openDialog}
        onClose={onClose}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: { borderRadius: "16px" },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            pb: 1,
            // padding: "12px",
          }}
        >
          <Typography variant="h6" color="#484848" fontWeight="500">
            Select Platforms For Quick Sharing
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Stack spacing={1} mt={1}>
            {platform?.map((platform) => (
              <Box
                key={platform.name}
                sx={{
                  backgroundColor: "#F8F6FD",
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  px: 1.5,
                  py: 0.8,
                }}
              >
                <Box display="flex" alignItems="center" gap={2}>
                  <Avatar
                    sx={{
                      bgcolor: "#fff",
                      width: 28,
                      height: 28,
                    }}
                    src={platform?.icon}
                    alt={platform?.name}
                  ></Avatar>
                  <Typography fontSize="16px" color="#5C5B5D" fontWeight="400">
                    {platform?.name}
                  </Typography>
                </Box>
                <Switch
                  checked={checked[platform?.name]}
                  onChange={() => handleToggle(platform?.name)}
                  color="primary"
                />
              </Box>
            ))}
          </Stack>

          <Box mt={4} display="flex" justifyContent="end" gap={2}>
            <Button
              onClick={onClose}
              disabled={shareLoading}
              sx={{
                backgroundColor: "#F8F6FD",
                color: "#003db3",
                borderRadius: "12px",
                textTransform: "none",
                px: 4,
                py: 1,
                fontWeight: 500,
                fontSize: "16px",
                "&:hover": {
                  backgroundColor: "#ece9fd",
                },
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleShare}
              variant="contained"
              disabled={shareLoading || !Object.values(checked).some(Boolean)}
              sx={{
                backgroundColor: "#003db3",
                color: "#fff",
                borderRadius: "12px",
                textTransform: "none",
                px: 4,
                py: 1,
                fontWeight: 500,
                fontSize: "16px",
                "&:hover": {
                  backgroundColor: "#002f8c",
                },
              }}
            >
              {shareLoading ? "Sharing..." : "Share"}
            </Button>
          </Box>
        </DialogContent>
      </Dialog>

      {/* Post Settings Dialog */}
      <Dialog
        open={openSettingsDialog}
        onClose={() => { if (!settingsSaving) setOpenSettingsDialog(false); }}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: "16px", px: 2, py: 1 } }}
      >
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", pb: 1, padding: "15px" }}>
          <Typography variant="h6" color="#484848" fontWeight="500">Post Settings</Typography>
          <IconButton onClick={() => setOpenSettingsDialog(false)} disabled={settingsSaving}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {/* Allow Edit toggle */}
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2, px: 1, py: 1.5, backgroundColor: "#F8F6FD", borderRadius: "12px" }}>
            <Typography fontSize="14px" color="#5C5B5D" fontWeight="400">Allow employees to edit caption</Typography>
            <Switch
              checked={settingsAllowEdit}
              onChange={(e) => setSettingsAllowEdit(e.target.checked)}
              color="primary"
              disabled={settingsSaving}
            />
          </Box>

          {/* Categories */}
          <Typography fontSize="13px" fontWeight={500} color="#484848" mb={1}>Categories</Typography>
          <List sx={{ maxHeight: 200, overflowY: "auto", mb: 2 }}>
            {categoryList?.categoriesData?.map((category) => {
              const isCat = settingsCategories.includes(category.id);
              return (
                <ListItem
                  key={category.id}
                  onClick={() => {
                    if (settingsSaving) return;
                    setSettingsCategories((prev) =>
                      prev.includes(category.id) ? prev.filter((id) => id !== category.id) : [...prev, category.id]
                    );
                  }}
                  sx={{ mb: 0.5, px: 2, py: 1, borderRadius: 2, bgcolor: "#f8f6fd", cursor: "pointer", display: "flex", justifyContent: "space-between", "&:hover": { bgcolor: "#F1F5F9" } }}
                >
                  <ListItemText primary={category?.name} primaryTypographyProps={{ fontSize: "13px" }} />
                  <Checkbox checked={isCat} sx={{ color: "#2563EB", "&.Mui-checked": { color: "#2563EB" }, p: 0 }} size="small" />
                </ListItem>
              );
            })}
          </List>

          {/* Edit Post button — hidden for social-media-sourced posts (fetched posts can only be deleted, not edited) */}
          {!isSocialSourcePost(settingsPost) && (
            <Button
              fullWidth
              startIcon={<img src={edit} alt="edit" style={{ width: 16, height: 16 }} />}
              onClick={handleOpenEditPost}
              disabled={settingsSaving}
              sx={{ textTransform: "none", color: "#003db3", backgroundColor: "#EEF2FF", borderRadius: "12px", py: 1, mb: 1.5, "&:hover": { backgroundColor: "#E0E7FF" } }}
            >
              Edit Post
            </Button>
          )}

          {/* Delete section */}
          {!deleteConfirm ? (
            <Button
              fullWidth
              startIcon={<DeleteOutlineIcon />}
              onClick={() => setDeleteConfirm(true)}
              disabled={settingsSaving}
              sx={{ textTransform: "none", color: "#DC2626", backgroundColor: "#FEF2F2", borderRadius: "12px", py: 1, "&:hover": { backgroundColor: "#FEE2E2" } }}
            >
              Delete Post
            </Button>
          ) : (
            <Box sx={{ backgroundColor: "#FEF2F2", borderRadius: "12px", p: 2, textAlign: "center" }}>
              <Typography fontSize="13px" color="#DC2626" mb={1.5}>Are you sure you want to delete this post? This cannot be undone.</Typography>
              <Box sx={{ display: "flex", gap: 1, justifyContent: "center" }}>
                <Button onClick={() => setDeleteConfirm(false)} disabled={settingsSaving} sx={{ textTransform: "none", color: "#484848", backgroundColor: "#F8F6FD", borderRadius: "8px", px: 3 }}>Cancel</Button>
                <Button onClick={handleDeletePost} disabled={settingsSaving} sx={{ textTransform: "none", color: "#fff", backgroundColor: "#DC2626", borderRadius: "8px", px: 3, "&:hover": { backgroundColor: "#B91C1C" } }}>
                  {settingsSaving ? <CircularProgress size={16} color="inherit" /> : "Delete"}
                </Button>
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 2, pb: 2, pt: 0, gap: 1 }}>
          <Button onClick={() => setOpenSettingsDialog(false)} disabled={settingsSaving} sx={{ backgroundColor: "#F8F6FD", color: "#003db3", borderRadius: "12px", textTransform: "none", px: 4, py: 1, fontWeight: 500, fontSize: "14px", "&:hover": { backgroundColor: "#ece9fd" } }}>
            Cancel
          </Button>
          <Button onClick={handleSaveSettings} disabled={settingsSaving} sx={{ backgroundColor: "#003db3", color: "#fff", borderRadius: "12px", textTransform: "none", px: 4, py: 1, fontWeight: 500, fontSize: "14px", "&:hover": { backgroundColor: "#002f8c" } }}>
            {settingsSaving ? <CircularProgress size={16} color="inherit" /> : "Save"}
          </Button>
        </DialogActions>
      </Dialog>


      {/* Featured post delete confirm dialog */}
      <Dialog
        open={!!featuredDeletePost}
        onClose={() => { if (!settingsSaving) setFeaturedDeletePost(null); }}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: "16px", px: 2, py: 1 } }}
      >
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "15px" }}>
          <Typography variant="h6" color="#484848" fontWeight="500">Delete Featured Post?</Typography>
          <IconButton onClick={() => setFeaturedDeletePost(null)} disabled={settingsSaving}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography fontSize="14px" color="#95919D">
            This will permanently delete the featured post. This action cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 2, pb: 2, pt: 0, gap: 1 }}>
          <Button
            onClick={() => setFeaturedDeletePost(null)}
            disabled={settingsSaving}
            sx={{ backgroundColor: "#F8F6FD", color: "#484848", borderRadius: "12px", textTransform: "none", px: 3, fontWeight: 500 }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleDeleteFeaturedPost}
            disabled={settingsSaving}
            sx={{ backgroundColor: "#DC2626", color: "#fff", borderRadius: "12px", textTransform: "none", px: 3, fontWeight: 500, "&:hover": { backgroundColor: "#B91C1C" } }}
          >
            {settingsSaving ? <CircularProgress size={16} color="inherit" /> : "Delete"}
          </Button>
        </DialogActions>
      </Dialog>
      {/* Connect Account Dialog */}
      <Dialog
        open={!!connectDialogPlatform}
        onClose={() => setConnectDialogPlatform(null)}
        PaperProps={{
          sx: { borderRadius: "16px", padding: "16px 20px", maxWidth: "420px", width: "100%" },
        }}
      >
        <IconButton
          onClick={() => setConnectDialogPlatform(null)}
          sx={{ position: "absolute", top: 16, right: 16 }}
        >
          <CloseIcon />
        </IconButton>
        <DialogTitle
          sx={{ fontWeight: "500", color: "#484848", fontSize: "20px", p: 0, mb: 1 }}
        >
          Account Not Connected
        </DialogTitle>
        <DialogContent sx={{ padding: "8px 0px 0px" }}>
          <Typography
            sx={{ fontSize: "16px", color: "#616161", mb: 3, textAlign: "start" }}
          >
            Please connect your {connectDialogPlatform} profile in case you want to share.
          </Typography>
          <Box display="flex" justifyContent="flex-end" gap={2}>
            <Button
              onClick={() => setConnectDialogPlatform(null)}
              sx={{
                backgroundColor: "#F4F0FF",
                color: "#0D47A1",
                textTransform: "none",
                fontSize: "16px",
                fontWeight: 500,
                borderRadius: "8px",
                px: 4,
                py: 1,
                "&:hover": { backgroundColor: "#E9D5FF" },
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                setConnectDialogPlatform(null);
                const basePath = isAdmin ? "/admin" : "/employees";
                navigate(`${basePath}/settings?open=personal`, { state: { openPersonalAccounts: true } });
              }}
              sx={{
                backgroundColor: "#003db3",
                color: "#fff",
                textTransform: "none",
                fontSize: "16px",
                fontWeight: 500,
                borderRadius: "8px",
                px: 4,
                py: 1,
                "&:hover": { backgroundColor: "#002f8c" },
              }}
            >
              Connect Account
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default PostCards;
